import { Link } from 'react-router-dom';
import { CadranGlyph } from './CadranGlyph.js';

const NAV_ITEMS = [
  { key: 'how', label: 'Comment ça marche', to: '/comment-ca-marche' },
  { key: 'pricing', label: 'Tarifs', to: '/tarifs' },
  { key: 'faq', label: 'Aide', to: '/faq' },
] as const;

interface Props {
  active?: 'home' | 'how' | 'pricing' | 'faq';
}

export function Nav({ active }: Props) {
  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Link className="brand" to="/">
          <CadranGlyph size={22} color="var(--ink)" />
          <span>Cadran</span>
        </Link>
        <div className="menu">
          {NAV_ITEMS.map((item) => (
            <Link key={item.key} to={item.to} className={active === item.key ? 'active' : ''}>
              {item.label}
            </Link>
          ))}
        </div>
        <div className="right">
          <Link className="login" to="/inscription">
            Connexion
          </Link>
          <Link className="cta" to="/inscription">
            Créer un foyer
          </Link>
        </div>
      </div>
    </nav>
  );
}
